export const headerProps = { color: "text.subheader", variant: "h4" };
